document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.scroll-sync-track');
  const stickyContainer = document.querySelector('safe-sticky.product-info');
  const listElement = document.querySelector('.product-info__block-list');
  const bottomElement = document.querySelector('.product-info__block-bottom');

  let currentScrollHandler = null;

  if (!track || !stickyContainer || !listElement) return;
  function initBodyScrollSync() {
    if (currentScrollHandler) {
      window.removeEventListener('scroll', currentScrollHandler);
      currentScrollHandler = null;
    }

    if (window.innerWidth < 999) {
      track.style.height = 'auto';
      listElement.style.transform = 'none';
      return;
    }

    const topOffset = 117; // 如果这个值也是动态的，可以用 stickyContainer.getBoundingClientRect().top
    const containerHeight = stickyContainer.clientHeight;
    const bottomHeight = bottomElement ? bottomElement.offsetHeight : 0;
    
    const listScrollHeight = listElement.scrollHeight;

    const listVisibleWindow = containerHeight - bottomHeight;
    const overflowDistance = listScrollHeight - listVisibleWindow;
    if (overflowDistance <= 0) {
      track.style.height = 'auto';
      listElement.style.transform = 'translate3d(0,0,0)';
      return;
    }

    track.style.height = (containerHeight + overflowDistance) + 'px';

    currentScrollHandler = function() {
      const rect = track.getBoundingClientRect();
      const trackTop = rect.top; 
      let translateY = 0;
      if (trackTop <= topOffset) {
        const scrolled = topOffset - trackTop;
        if (scrolled >= overflowDistance) {
          translateY = overflowDistance;
        } else {
          translateY = scrolled;
        }
      } else {
        translateY = 0;
      }

      listElement.style.transform = `translate3d(0, -${translateY}px, 0)`;
    };

    window.addEventListener('scroll', currentScrollHandler, { passive: true });
    
    currentScrollHandler();
  }

  initBodyScrollSync();

  window.addEventListener('load', initBodyScrollSync);

  const resizeObserver = new ResizeObserver(() => {
    window.requestAnimationFrame(() => {
      initBodyScrollSync();
    });
  });
  resizeObserver.observe(listElement);
  resizeObserver.observe(stickyContainer);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initBodyScrollSync, 100);
  });
});